/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// Create Mutation Observer
const qtySelector = document.querySelector('.static-quantity-selector');
const qtyInput = document.querySelector('#product-quantity');
const qtyButtons = document.querySelectorAll('.quantity-btn');
const firstQtyBtn = qtyButtons[0]; 
const firstQtyValue = firstQtyBtn?.dataset.qty || 1;
function setFirstQtyActive() {
  qtyButtons.forEach(btn => btn.classList.remove('active'));
  if (firstQtyBtn) firstQtyBtn.classList.add('active');
  qtyInput.value = firstQtyValue;
}
function toggleQty() {
  const wrapper = document.querySelector('.appstle_subscription_wrapper');
  if (!wrapper) return;
  const hasSubscription = [...wrapper.querySelectorAll('input')]
    .some(input => (input.checked || input.type === 'hidden') && input.value.trim() !== "");
  if (hasSubscription) {
    qtySelector.style.display = "none";
    qtyInput.value = 1; 
    qtyButtons.forEach(btn => btn.classList.remove('active'));
  } else {
    qtySelector.style.display = "";
    setFirstQtyActive(); 
  }
  udpateStickyPrice(wrapper);
}
function udpateStickyPrice(wrapper){
  const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
  const checkedInput = [...wrapper.querySelectorAll('input')].find(input=> input.checked);
  const closestOption = checkedInput.closest('.appstle_subscription_wrapper_option');
  if(closestOption){
    const mainPrice = closestOption.querySelector('.appstle_subscription_amount');
    const mainComparePrice = closestOption.querySelector('.appstle_subscription_amount_compare_at_price');
    if(stickyAddToCart){
      const mainPriceStickyBar = stickyAddToCart.querySelector('.current-price');
      const mainComparePriceStickyBar = stickyAddToCart.querySelector('.original-price');
      if(mainPriceStickyBar && mainPrice){
        mainPriceStickyBar.innerText = mainPrice.innerText;
      }
      if(mainComparePriceStickyBar && mainComparePrice && mainComparePrice.innerText != ''){
        mainComparePriceStickyBar.innerText = mainComparePrice.innerText;
        mainComparePriceStickyBar.removeAttribute('hidden');
      } else{
        mainComparePriceStickyBar.setAttribute('hidden', true);
      }
    }
  }
}
const _stickyAddToCart = document.querySelector('.sticky-add-to-cart');
const static_quantity_selector = document.querySelector('.static-quantity-selector');
if(static_quantity_selector){
  const allButtons = static_quantity_selector.querySelectorAll('.quantity-btn');
  if(allButtons.length > 0){
    allButtons.forEach(button=>{
      button.addEventListener('click', ()=>{
        const comparePrice = button.querySelector('.original-price');
        let mainPrice = button.querySelector('.discounted-price');
        const one_time_price = document.querySelector('.appstle_one_time_details_wrapper .appstle_subscription_amount');
        if(one_time_price){
        one_time_price.innerText = mainPrice.innerText;
      } 
        if(_stickyAddToCart){
          const mainPriceStickyBar = _stickyAddToCart.querySelector('.current-price');
          const mainComparePriceStickyBar = _stickyAddToCart.querySelector('.original-price');
          if(mainPrice && mainPriceStickyBar){
            mainPriceStickyBar.innerText = mainPrice.innerText;
          } else{
            mainPrice = button.querySelector('.price-text');
            if(mainPrice && mainPriceStickyBar){
              mainPriceStickyBar.innerText = mainPrice.innerText;
            }
          }
          if(mainComparePriceStickyBar && comparePrice && comparePrice.innerText != ''){
            mainComparePriceStickyBar.innerText = comparePrice.innerText;
            mainComparePriceStickyBar.removeAttribute('hidden');
          } else{
            mainComparePriceStickyBar.setAttribute('hidden', true);
          }
        }
      })
    })
  }
}
const observer = new MutationObserver(() => {
  const wrapper = document.querySelector('.appstle_subscription_wrapper');
  if (wrapper) {
    toggleQty();
    wrapper.addEventListener('change', toggleQty);
    observer.disconnect();
  }
});
observer.observe(document.body, { childList: true, subtree: true });





